import React from 'react'

import FormToggle from "../../../../gd-form/form-element/toggle-new/toggle"
import SettingsHelp from "../setting-help/setting-help"

type Props = {
    title               : string
    value               : boolean | undefined

    hintRight?          : string
    help?               : string

    disabled?           : boolean
    className?          : string
    labelClassName?     : string

    onChange            : {(value:boolean):void}
    size?               : '16' | '18' | '20'
}

export default function SettingsToggle(props:Props) {

    const size = _.get(props, 'size', '18')

    return (
        <div className={Classes("settings-toggle", props.className)}>

            <div className={Classes("label ui5-txt-not-important-small", props.labelClassName)}>{props.title}</div>
            <FormToggle value={props.value} onChange={props.onChange} size="18" disabled={props.disabled}/>
            {props.hintRight && <div className="hint-right ui5-txt-no-accent-small m-l-20">{props.hintRight}</div>}
            {props.help && <SettingsHelp help={props.help}/>}

        </div>
    )

}
